import * as React from 'react';
import ProductsTabsView from './components/ProductsTabs';
import ProductGridsView from 'app/pages/Products/components/ProductGrids';
import { ProductsOpenProductBootstrap } from './components/ProductsOpenProductBootstrap';
import { Row, Col } from 'antd';


export class Page extends React.Component {
    render() {

        return <div>
                    <ProductsOpenProductBootstrap />
                    <Row>
                        <Col span={24}>
                            <h1 id="pricelist-header">Products</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <ProductsTabsView />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24}>
                            <ProductGridsView />
                        </Col>
                    </Row>
               </div>
    }

    componentDidMount() {
        const header = document.getElementById('products-header');
        const headerClientRects = header ? header.getClientRects() : null;
    }    
}